import client from './client';
import { InvoiceUploadResult, InvoicesResponse, UploadedInvoice } from '../types/invoice';

export async function getInvoices(params: {
  from?: string;
  to?: string;
  supplier_name?: string;
}): Promise<InvoicesResponse> {
  const res = await client.get('/api/admin/invoices', {
    params: {
      ...(params.from ? { from: params.from } : {}),
      ...(params.to ? { to: params.to } : {}),
      ...(params.supplier_name ? { supplier_name: params.supplier_name } : {}),
    },
  });
  const raw = res.data ?? {};
  return {
    invoices: (Array.isArray(raw.invoices) ? raw.invoices : []) as UploadedInvoice[],
    // Absent means an older service build that predates the flag — assume
    // configured rather than showing a false "not set up" warning.
    drive_configured: raw.drive_configured !== false,
  };
}

export async function uploadInvoice(
  input: {
    file: File;
    invoice_date: string;
    supplier_name?: string;
    amount?: string;
    description?: string;
  },
  onProgress?: (percent: number) => void
): Promise<InvoiceUploadResult> {
  const form = new FormData();
  form.append('file', input.file);
  form.append('invoice_date', input.invoice_date);
  if (input.supplier_name) form.append('supplier_name', input.supplier_name);
  if (input.amount) form.append('amount', input.amount);
  if (input.description) form.append('description', input.description);

  const res = await client.post('/api/admin/invoices/upload', form, {
    // The shared client sets Content-Type: application/json for every request.
    // Clearing it here is required, not stylistic: multipart bodies are framed
    // by a boundary token that only the browser can generate, and it will only
    // do so if no Content-Type is already set.
    headers: { 'Content-Type': undefined },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  });

  return {
    invoice: res.data?.invoice,
    drive_path: res.data?.drive_path ?? '',
  };
}
